const ParamConfig = ()=>{
    return (
        <div>
            参数配置
        </div>
    )
}
export default ParamConfig;